import { Component, ElementRef, EventEmitter, HostListener, OnInit, Output, ViewChild, ViewContainerRef } from '@angular/core';
import { Paginated } from 'src/app/utils/interfaces/new/paginated.interface';
import { CritereService } from 'src/app/services/critere/critere.service';
import { Consultation } from 'src/app/utils/interfaces/new/consultation.interface';
import { ConsultationService } from 'src/app/services/consultation/consultation.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { VisualisationConsultation } from 'src/app/utils/interfaces/new/visualisation-consultation.interface';
import { ReferentielService } from 'src/app/services/referentiel/referentiel.service';
import { GroupeService } from 'src/app/services/groupe/groupe.service';
import { ReferentielEnum } from 'src/app/utils/enums/referentiel-enum';
import { environment } from 'src/environments/environment';
import { ModalService } from 'src/app/services/modal/modal.service';

interface SelectFactor {
  doSelect: boolean;
  factorId: string;
}

@Component({
  selector: 'app-select-consultation',
  templateUrl: './select-consultation.fragment.html',
  styleUrls: [
    './select-consultation.fragment.scss',
    '../modal.fragment.scss'
  ]
})
export class SelectConsultationFragment implements OnInit {

  @ViewChild('modalBody') public modalBody: ElementRef;
  @ViewChild('outsideModal') public outsideModal: ElementRef;

  @Output() public closeEmitter = new EventEmitter();

  @HostListener('document:mousedown', ['$event'])
  onGlobalClick(event): void {
    if (!environment.closeModalOnClickOutside) {
      return;
    }

    if (!this.modalBody.nativeElement.contains(event.target) && this.outsideModal.nativeElement.contains(event.target)) {
      this.closeAddEditModal();
    }
  }

  visualForm: FormGroup;

  untouchedConsultations: Consultation[] = [];
  consultBodyTable: Paginated<Consultation> = {
    page: 1,
    perpage: -1,
    objects: [],
    total: 0,
  };
  consultColumnTable = [
    { title: 'Date', data: 'date' },
    { title: 'Titre', data: 'titre' },
    { title: 'Type', data: 'typeConsultation' },
    { title: 'Statut', data: 'statut' },
    { title: 'Groupe', data: 'idGroupe' }
  ];

  addFactor: any;

  selectedConsult: Consultation[] = [];


  constructor(
    private _builder: FormBuilder,
    private _ref: ReferentielService,
    private _groupe: GroupeService,
    private _modalSrv :  ModalService,
    public viewContainerRef: ViewContainerRef
  ) { }


  async ngOnInit(): Promise<void> {
    const typeConsultListe = await this._ref.findRefListTable(ReferentielEnum.typeConsultation);
    const groupeListe = (await this._groupe.find()).objects;
    for (let consult of this.untouchedConsultations) {
      const newConsType = typeConsultListe.find(x => x.id === (consult.typeConsultation ? consult.typeConsultation : ''));
      const newConsGroupe = groupeListe.find(x => x.id === (consult.idGroupe ? consult.idGroupe : ''));
      consult.typeConsultation = newConsType ? newConsType.libelle : '';
      consult.idGroupe = newConsGroupe ? newConsGroupe.nom : '';
      this.consultBodyTable.objects.push(consult);
    }
    this.untouchedConsultations = this.consultBodyTable.objects;
    this.visualForm = this._builder.group({
      isAll: [false],
      isDiagnosticTexte: [false],
      isDiagnosticGuide: [false],
      isOrdonnance: [false],
      isCourrier: [false],
      isImagerie: [false],
    });
  }

  public closeAddEditModal(object?: any): void {
    if (object) {
      this.closeEmitter.emit(object);
    } else {
      this.closeEmitter.emit(null);
    }
  }

  onSearchCritere(event: any) {
  this.consultBodyTable.objects = this.untouchedConsultations.filter(x => {
      return (
        (x.titre && x.titre.toLowerCase().includes(event.toLowerCase())) ||
        (x.typeConsultation && x.typeConsultation.toLowerCase().includes(event.toLowerCase())) ||
        (x.statut && x.statut.toLowerCase().includes(event.toLowerCase())) ||
        (x.idGroupe && x.idGroupe.toLowerCase().includes(event.toLowerCase()))
      );
    });
  }
  sendVisuals() {
    const loader = this._modalSrv.openLoading(this.viewContainerRef);
    try {
      if (this.selectedConsult.length > 0) {
        let visualList: VisualisationConsultation[] = [];

        for (let consult of this.selectedConsult) {
          const newVisual: VisualisationConsultation = {
            idConsultation: consult.id,
            isAll: this.visualForm.controls['isAll'].value,
            isDiagnosticTexte: this.visualForm.controls['isDiagnosticTexte'].value,
            isDiagnosticGuide: this.visualForm.controls['isDiagnosticGuide'].value,
            isOrdonnance: this.visualForm.controls['isOrdonnance'].value,
            isCourrier: this.visualForm.controls['isCourrier'].value,
            isImagerie: this.visualForm.controls['isImagerie'].value,
          }
          visualList.push(newVisual);
        }

        this.closeAddEditModal(visualList);
      } else {
        this.closeAddEditModal();
      }     
    } catch (error) {
      console.error(error);
    } finally {
      loader.destroy();
      this._modalSrv.close(loader);
    }
  }

  public addRemoveFactor(event: any): void {
    if (this.selectedConsult.indexOf(event, 0) > -1) {
      this._doSelectFactor({ doSelect: false, factorId: event.id });
      const index = this.selectedConsult.indexOf(event, 0);
      if (index > -1) {
        this.selectedConsult.splice(index, 1);
      }
    } else {
      this._doSelectFactor({ doSelect: true, factorId: event.id });
      this.selectedConsult.push(event);
    }
  }

  private _doSelectFactor(factor: SelectFactor): void {
    if (this.consultBodyTable && this.consultBodyTable.objects) {
      const index = this.consultBodyTable.objects.findIndex(p => p.id === factor.factorId);
      const factorDisplayTable = this.consultBodyTable.objects.find(p => p.id === factor.factorId);

      if (factor.doSelect) {
        Object.defineProperty(factorDisplayTable, 'rowColor', { configurable: true, value: 'var(--primary)' });
        Object.defineProperty(factorDisplayTable, 'textColor', { configurable: true, value: 'var(--white)' });
      } else {
        Object.defineProperty(factorDisplayTable, 'rowColor', { configurable: true, value: 'transparent' });
        Object.defineProperty(factorDisplayTable, 'textColor', { configurable: true, value: 'var(--black)' });
      }

      this.consultBodyTable.objects.splice(index, 1, factorDisplayTable);
    }
  }
}
